import { TechnicalStandards } from '../../components/TechnicalStandards'

export const CopelTechnicalStandards = () => {
  return (
    <div className="flex flex-column min-h-screen">
      {/* <header className="mb-3" style={{ zIndex: '9' }}> */}
      {/*   <embed src="https://hpshml.apps.ose43prd.copel.nt/site/header/" className="w-full h-full"></embed> */}
      {/* </header> */}

      <div className="flex justify-content-center flex-grow-1" style={{ zIndex: '1' }}>
        <TechnicalStandards />
      </div>

      {/* <footer className="mt-3"> */}
      {/*   <embed src="https://hpshml.apps.ose43prd.copel.nt/site/footer/" className="w-full h-full"></embed> */}
      {/* </footer> */}
    </div>
  )
}
